import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTablePFSEvent } from "primereact/datatable";
import { UserRoles } from "../../../../constants/userRoles";
import { PrivateAccess } from "../../../../keycloak";
import { TItem } from "../types";
import classes from "./ItemList.module.scss";

type ItemListProps = {
  first?: number;
  rows?: number;
  totalRecords?: number;
  records: [any];
  rowActionEdit: (rowData: any) => void;
  rowActionDelete: (rowData: any) => void;
  onPage: (e: DataTablePFSEvent) => void;
};

export const ItemList = ({
  first,
  rows,
  totalRecords,
  records,
  rowActionDelete,
  rowActionEdit,
  onPage,
}: ItemListProps) => {
  const actionBodyTemplate = (rowData: any) => {
    return (
      <div className={classes.tableActions}>
        <PrivateAccess
          roles={{
            dcs_client: [
              UserRoles.CONTRACT_TYPE_UPDATE,
              UserRoles.TYPE_OF_FLOOR_SURFACES_UPDATE,
              UserRoles.SUPPLIES_UPDATE,
              UserRoles.PAPER_PRODUCTS_UPDATE,
              UserRoles.DENIED_REASON_TYPE_UPDATE,
            ],
          }}
        >
          <Button
            icon="pi pi-pencil"
            className="p-button-primary mr-2 p-button-sm"
            onClick={() => rowActionEdit(rowData)}
          />
        </PrivateAccess>
        <PrivateAccess
          roles={{
            dcs_client: [
              UserRoles.CONTRACT_TYPE_DELETE,
              UserRoles.TYPE_OF_FLOOR_SURFACES_DELETE,
              UserRoles.SUPPLIES_DELETE,
              UserRoles.PAPER_PRODUCTS_DELETE,
              UserRoles.DENIED_REASON_TYPE_DELETE,
            ],
          }}
        >
          <Button
            icon="pi pi-trash"
            className="p-button-danger p-button-sm"
            onClick={() => rowActionDelete(rowData)}
          />
        </PrivateAccess>
      </div>
    );
  };
  return (
    <DataTable
      value={records}
      paginator
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPage={onPage}
      paginatorPosition="top"
      paginatorClassName={classes.paginator}
      lazy
    >
      <Column field="name" header="Name"></Column>
      {records?.some((record) => "hasExplicitAirslateTemplate" in record) ? (
        <Column
          header="AirSlate"
          body={(rowData: TItem) =>
            rowData.hasExplicitAirslateTemplate ? "Explicit" : "Generic fallback"
          }
        />
      ) : null}
      <Column
        style={{ width: "150px" }}
        body={actionBodyTemplate}
        header="Actions"
      ></Column>
    </DataTable>
  );
};
